<template>
    <div class="af-search-sort afu-ml-4">
        <C1Select
            v-model="getSortBy"
            label=""
            label-for="sortBy"
            :options="sortOptions"
            @input="updateSort()"
            :scrollable="false"
        />
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import C1Select from '@/components/C1Components/C1Select';

    export default {
        name: 'SortSearch',

        components: {
            C1Select,
        },

        data() {
            return {
                sortOptions: [
                    { id: 1, label: this.$t('label.relevance'), value: 'relevance' },
                    { id: 2, label: this.$t('label.date_posted'), value: 'activates_at' },
                ],
            };
        },

        computed: {
            ...mapState({
                $_search: state => state.search,
            }),

            getSortBy: {
                get() {
                    let sort_by = this.$_search.searchPayload.search_filters.sort_by;
                    if (typeof sort_by === 'object') {
                        sort_by = sort_by?.sort_by || this.sortOptions[0];
                    }
                    if (sort_by) {
                        if (sort_by === 'refreshed_at' || sort_by === 'activates_at') {
                            return this.sortOptions[1];
                        } else  {
                            return this.sortOptions[0];
                        }
                    } else {
                        return this.sortOptions[0];
                    }
                },

                set(sortBy) {
                    this.$_SET_SEARCH_FILTERS({ key: 'sort_by', value: sortBy.value });
                },
            },
        },

        methods: {
            ...mapMutations('search', {
                $_SET_SEARCH_FILTERS: 'SET_SEARCH_FILTERS',
            }),

            updateSort() {
            },
        },
    };
</script>
